// extracted by mini-css-extract-plugin
export default {"gradientBoxContainer":"GradientBox_gradientBoxContainer__qu1Xe"};